module.exports = __webpack_public_path__ + "assets/img/facergt-app1.f56ea633.png";